module.exports = __webpack_public_path__ + "img/stas-main_480.62542463.webp";